// ═══════════════════════════════════════════════════════════════
// API: Solicitudes
// ═══════════════════════════════════════════════════════════════

import api from './config';

export const solicitudesAPI = {
  getTipos: () =>
    api.get('/solicitudes/tipos').then(r => r.data),

  getStats: () =>
    api.get('/solicitudes/stats').then(r => r.data),

  getAll: (params = {}) =>
    api.get('/solicitudes', { params }).then(r => r.data),

  getById: (id) =>
    api.get(`/solicitudes/${id}`).then(r => r.data),

  crear: (data) =>
    api.post('/solicitudes', data).then(r => r.data),

  aprobar: (id, data = {}) =>
    api.put(`/solicitudes/${id}/aprobar`, data).then(r => r.data),

  rechazar: (id, data) =>
    api.put(`/solicitudes/${id}/rechazar`, data).then(r => r.data),

  completar: (id, data = {}) =>
    api.put(`/solicitudes/${id}/completar`, data).then(r => r.data),

  cancelar: (id) =>
    api.put(`/solicitudes/${id}/cancelar`).then(r => r.data),

  cambiarEstado: (id, estado, comentario) =>
    api.patch(`/solicitudes/${id}/estado`, { estado, comentario }).then(r => r.data),
};
